import './styles/front.scss';
import { notifications } from "@src/front-notifications";
// Dynamically set public path to the directory where the current script is running from
// @ts-ignore
//__webpack_public_path__ = document.currentScript.src.replace(/\/scripts\/[^\/]+$/, '/');
document.addEventListener('DOMContentLoaded', async () => {
    await notifications();
});
